// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    /* Primitive tokens */
    --gw-height-0: 0px;
    --gw-height-025: 1px;
    --gw-height-050: 2px;
    --gw-height-100: 4px;
    --gw-height-150: 6px;
    --gw-height-200: 8px;
    --gw-height-300: 12px;
    --gw-height-400: 16px;
    --gw-height-500: 20px;
    --gw-height-600: 24px;
    --gw-height-800: 32px;
    --gw-height-1000: 40px;
    --gw-height-1200: 48px;
    --gw-height-1600: 64px;
    --gw-height-2000: 80px;
    --gw-height-2400: 96px;
    --gw-height-2800: 112px;
    --gw-height-3200: 128px;
}
`, "",{"version":3,"sources":["webpack://./src/themes/default_v2/height.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B","sourcesContent":[":root,\n:host {\n    /* Primitive tokens */\n    --gw-height-0: 0px;\n    --gw-height-025: 1px;\n    --gw-height-050: 2px;\n    --gw-height-100: 4px;\n    --gw-height-150: 6px;\n    --gw-height-200: 8px;\n    --gw-height-300: 12px;\n    --gw-height-400: 16px;\n    --gw-height-500: 20px;\n    --gw-height-600: 24px;\n    --gw-height-800: 32px;\n    --gw-height-1000: 40px;\n    --gw-height-1200: 48px;\n    --gw-height-1600: 64px;\n    --gw-height-2000: 80px;\n    --gw-height-2400: 96px;\n    --gw-height-2800: 112px;\n    --gw-height-3200: 128px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
